<template>
    <div class="page">
        <van-search
                class="search"
                shape="round"
                v-model="keyword"
                placeholder="请输入关键词搜索"
                @search="onSearch"
        />
        <van-pull-refresh class="pull-refresh" v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    @load="onLoad"
                    style="min-height: 100vh;"
            >
                <div class="item" v-for="(item,index) in list"
                     :key="item.id" @click="toDetail(item.id)">
                    <van-image
                            class="image"
                            :src="item.routeImg"
                            fit="cover"
                            radius="5 5 0 0"
                    />
                    <div class="info-box">
                        <span class="title">{{item.routeName}}</span>
                        <div class="tag-box">
                            <van-tag class="tag" v-for="(tag,iindex) in item.routeLabel" :type="tagType(index+iindex)">
                                {{tag}}
                            </van-tag>

                        </div>

                    </div>
                </div>
            </van-list>
            <van-empty v-if="finished && list.length<=0" description="暂无数据"/>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {PullRefresh, List, Image as VanImage, Empty, Search,Tag} from 'vant';
    import {akRouteList} from '@/api/route.js';

    export default {
        name: "routeList",
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [VanImage.name]: VanImage,
            [Empty.name]: Empty,
            [Search.name]: Search,
            [Tag.name]:Tag
        },
        data() {
            return {
                refreshing: false,
                finished: false,
                loading: false,
                pageNum: 0,
                list: [],
                keyword: '',
            };
        },
        created() {
        },
        methods: {

            /**
             * 触发上拉加载
             */
            onLoad() {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                this.pageNum += 1;
                this.getList(true)
            },
            /**
             * 触发下拉刷新
             */
            onRefresh() {
                if (this.loading) {
                    this.list = [];
                    this.loading = false;
                }
                this.finished = false;
                this.pageNum = 1;
                this.getList(false);
            },

            onSearch(val) {
                this.keyword = val;
                this.onRefresh();
            },

            /**
             *获取列表数据
             */
            async getList(loadMore) {
                try {
                    const data = await this.akList()
                    this.loading = false;
                    this.refreshing = false;
                    this.list = loadMore ? this.list.concat(data.list) : data.list
                    this.finished = this.list.length >= data.total
                } catch (e) {
                    this.loading = false
                }
            },

            /**
             * 获取列表数据网络请求
             */
            akList() {
                const pageNum = this.pageNum;
                const pageSize = 20;
                const routeName = this.keyword;
                const option = {
                    pageNum,
                    pageSize,
                    routeName
                }
                return new Promise((resolve, reject) => {
                    akRouteList(option).then((res) => {
                        resolve(res)
                    }).catch((e) => {
                        reject(e)
                        this.finished = true
                    })
                })
            },

            /**
             *跳转至详情页
             */
            toDetail(id) {
                this.$router.push({
                    name: "routeDetail",
                    query: {
                        id: id,
                    }
                });
            },

            /**
             *标签类型
             */
            tagType(typeIndex){
                let type=typeIndex % 4;
                let typeText='primary'
                switch (type) {
                    case 0:
                        typeText='primary'
                        break;
                    case 1:
                        typeText='danger'
                        break;
                    case 2:
                        typeText='warning'
                        break;
                    case 3:
                        typeText='success'
                        break;
                }
                return typeText;
            }
        }
    }
</script>

<style scoped lang="scss">
    .page {
        position: relative;
    }

    .search {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
    }

    .pull-refresh {
        width: 100%;
        box-sizing: border-box;
        margin-top: 54px;
    }

    .van-empty {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    .item {
        width: 100%;
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        border-radius: 5px;
        overflow: hidden;
        margin-top: 10px;

        .image {
            width: 100%;
            height: 150px;
            border-radius: 5px 5px 0 0;
        }

        .info-box {
            width: 100%;
            display: flex;
            padding: 10px;
            flex-direction: column;
            justify-content: space-between;
            background-color: white;
            border-radius: 0 0 5px 5px;
            box-sizing: border-box;

            .title {
                font-size: 14px;
                color: #333333;
                font-weight: bold;
                line-height: 22px;
            }
        }
    }

    .tag-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 5px;

        .tag {
            margin-right: 5px;
        }
    }
</style>
